import React from 'react';
import video from './video/bgvideo.mp4'
import './bgVideo.css'
const backgroundVideo = () => {
    return (
        <div className='bgVideo'>
            <video autoPlay loop muted data-keepplaying>
                <source src={video} type='video/mp4'/>
            </video>
        </div>
    );
};

export default backgroundVideo;